module.exports = __webpack_public_path__ + "static/img/sg2.535c21b.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/control2/sg2.png
// module id = /zjm
// module chunks = 7